<template lang="pug">
div
	lessonHeader
	lessonTitle
	paging
	lessonFooter
</template>

<script>

import { mapGetters } from 'vuex';
import lessonHeader from "@/components/lesson-header/lesson-header";
import lessonTitle from '@/components/lesson-title/lesson-title'
import paging from '@/components/paging/paging'
import lessonFooter from "@/components/lesson-footer/lesson-footer";

export default {
	name: 'Escenario2',
	components:{
		lessonHeader,
		lessonTitle,
		paging,
		lessonFooter
	},
	computed: {
    	...mapGetters(['currentStep'])
  	}
}
</script>

<style scoped>
@import 'escenario2.scss';
</style>